import clsx from "clsx";

interface TabNabItem {
  name: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

interface Props {
  items: TabNabItem[];
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
}

export const TabNav = ({ items, selectedTab, setSelectedTab }: Props) => {
  return (
    <div className="flex">
      {items.map((item, index) => (
        <div className="relative">
          <button
            type="button"
            onClick={() => setSelectedTab(item.name)}
            className={clsx(
              "mr-2 flex items-center border rounded-md px-2 py-0.5 dark:hover:bg-zinc-800 flex cursor-pointer group transition duration-200 ease-in-out",
              selectedTab === item.name
                ? "dark:border-white/5 dark:bg-zinc-700/20 dark:text-zinc-300 text-zinc-500"
                : "border-transparent hover:border-zinc-200 dark:hover:dark:border-white/5 hover:text-zinc-600 dark:hover:text-zinc-300 hover:border-white/10 dark:hover:bg-dark-primary text-zinc-500 hover:text-zinc-300"
            )}
          >
            <item.icon className="h-4 w-4 inline-block mr-1" />
            <span className="text-sm">{item.name}</span>
          </button>

          {selectedTab === item.name && (
            <div className="absolute mt-2 w-full pr-2">
              <div className="h-[0.02rem] w-full bg-zinc-300"></div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
